import * as React from 'react'
import * as Redux from 'redux'
import * as Tgcc from '../tgccGlobal'
import { connect } from 'react-redux'
import { CSSProperties } from 'react'
import { Diamonds } from '../Components/Diamonds'
import { ProofCard } from '../Components/ProofCard'
import { browserHistory } from 'react-router'
import * as Request from '../tgccRequest'


const wrapperStyle: React.CSSProperties = {
    backgroundColor: 'white',
    alignSelf: 'center',
    fontFamily: 'CenturyGothic',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    color: Tgcc.Styles.darkTextColor,
    fontSize: '13px',
    padding: '25px',
    width: '450px',
    maxWidth: '80%',
    borderRadius: '20px',
    marginBottom: '20px'
}

const rowStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'nowrap',
    height: '35px',
}
let szRowStyle = Object.assign({}, rowStyle, { margin: "0 30px" });

const labelStyle: React.CSSProperties = {
    display: 'flex',
    letterSpacing: '2px',
    flexShrink: 1,
    flexGrow: 1
}
let szLblStyle = Object.assign({}, labelStyle, { flexBasis: '90px', justifyContent: 'flex-end', marginRight: '3px', fontFamily: 'Lulo' });
const szDivider = Object.assign({}, labelStyle, { flexBasis: '30px' });

const inputStyle: React.CSSProperties = {
    color: Tgcc.Styles.darkTextColor,
    backgroundColor: 'white',
    lineHeight: '18px',
    height: '18px',
    width: '100px',
    marginLeft: '3px',
    padding: '2px',
    fontSize: '13px',
    display: 'flex',
    flexShrink: 1,
    flexGrow: 1,
    border: '1px solid #E9E6E6'
}

let orgLblStyle = { flexBasis: '110px' };
let nameLblStyle = { flexBasis: '90px', fontFamily: 'Lulo' };
let emailLblStyle = { flexBasis: '70px', fontFamily: 'Lulo' };
let orgStyle = Object.assign({}, inputStyle, { flexBasis: '220px' });
let nameStyle = Object.assign({}, inputStyle, { flexBasis: '140px', fontFamily: 'BarlowLight' });
let emailStyle = Object.assign({}, inputStyle, { flexBasis: '310px', fontFamily: 'BarlowLight' });
let numberStyle = Object.assign({}, inputStyle, { width: '40px', textAlign: 'right', marginRight: "10px", fontFamily: 'BarlowLight' })
let addrlineStyle = Object.assign({}, inputStyle, { width: '317px', marginRight: "10px", fontFamily: 'BarlowLight' });
let cityStyle = Object.assign({}, inputStyle, { width: '160px', marginRight: "10px", fontFamily: 'BarlowLight' });
let stateStyle = Object.assign({}, inputStyle, { width: '40px', maxlength: 2, marginRight: "10px", fontFamily: 'BarlowLight' });
let zipStyle = Object.assign({}, inputStyle, { width: '65px', maxlength: 10, marginRight: "10px", fontFamily: 'BarlowLight' });
let hdrStyle = Object.assign({}, labelStyle, { fontSize: '16px', fontWeight: 'bold', display: 'block', textAlign: "center", marginBottom: '10px' });
let checkLabelStyle = Object.assign({}, labelStyle, { fontWeight: 'normal', letterSpacing: '1.2px', fontSize: '12px', textAlign: "center", flexShrink: 'none', flexGrow: 'none' });
let checkRowStyle = Object.assign({}, rowStyle, { flexGrow: 'none', justifyContent: 'space-around' })
let errorStyle = Object.assign({}, Tgcc.Styles.error, { fontSize: '13px', maxWidth: '100%', padding: '0 10px' });

const shipCheckStyle: React.CSSProperties = {
    display: 'flex',
    lineHeight: '22px',
    height: '15px',
    width: '15px',
    alignSelf: 'baseline'
}
const hrStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    width: '85%',
    margin: '15px 0'
}

const thanksStyle: React.CSSProperties = {
    height: '45px',
    lineHeight: '45px',
    fontSize: '40px',
    fontFamily: 'BarlowMedium',
    textTransform: 'none'
}

const orderBtn: React.CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#E27558',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0px 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0px',
}

const closedBtn: React.CSSProperties = {
    display: 'table',
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'Lulo',
    fontSize: '28px',
    textTransform: 'uppercase',
    letterSpacing: '10px',
    color: 'white',
    background: '#E27558',
    padding: '5px 40px',
    margin: '5px auto 10px',
    cursor: 'pointer',
}

const proseStyle: React.CSSProperties = {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    fontFamily: 'BarlowMedium',
    textTransform: 'none',
    textAlign: 'center',
    padding: '0,10,0,10'
}

const shipHighlightColor: string = '#D47C61';

const shipHdrStyle: React.CSSProperties = {
    fontSize: '24px',
    fontWeight: 'bold',
    letterSpacing: '2.8px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: shipHighlightColor,
    marginBottom: '10px'
}

const inlineHighlightAllCaps: React.CSSProperties = {
    color: shipHighlightColor,
    textTransform: 'uppercase'
}
const inlineHighlightAllCapsBold: React.CSSProperties = {
    color: shipHighlightColor,
    textTransform: 'uppercase',
    fontWeight: 'bold'
}
const inlineHighlightBold: React.CSSProperties = {
    fontWeight: 'bold',
    textTransform: 'uppercase'
}

class Props {
    tvite: Tgcc.TviteInfo;
    purchaseComplete: boolean;
}

export class CampusTVitePurchase extends React.Component<Props, any>{
    state = {
        error: null,
        isWaiting: false,
        Organization: "",
        FirstName: "",
        LastName: "",
        Email: "",
        Small: 0,
        Medium: 0,
        Large: 0,
        XLarge: 0,
        XXL: 0,
        XXXL: 0,
        YXSmall: 0,
        YSmall: 0,
        YMedium: 0,
        YLarge: 0,
        YXLarge: 0,
        payment: null,
        purchaseComplete: false,
        sizesList: null,
        individualShip: false,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null
    };
    
    componentWillMount() {
        if (this.props.tvite.proofId) {
            Request.getOneProof(this.props.tvite.proofId, this.productFound, this.loadError);
        }
    }

    productFound = (proof: Tgcc.Proof) => {
        if (proof != null) {
            Request.getSizes(proof.product.brand, proof.product.style, proof.product.colorName, this.sizesFound, this.loadError);
        }
    }

    sizesFound = (products: Tgcc.Product[]) => {
        this.setState({ sizesList: products })

    }
    getSizesList = () => {
        var productSizes = new Array();
        if (this.state.sizesList) {
            for (var x in this.state.sizesList) {
                productSizes.push(this.state.sizesList[x].Size);
            }
        }
        return productSizes;
    }
    checkXSmall = () => {
        var sizeList = this.getSizesList();
        for (var y in sizeList) {
            if (sizeList[y] == "XSmall") {
                return "yes";
            }
        }
    }

    loadError = (err: any) => {
        this.setState({ sizesList: [], isWaiting: false });
        console.log("error loading tvite: ", err);
    }

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }

    handleFieldChange = (evt: React.FormEvent<HTMLInputElement>) => {
        var fldChange = {};
        if (evt.currentTarget.type == 'number')
            fldChange[evt.currentTarget.name] = parseInt(evt.currentTarget.value);
        else
            fldChange[evt.currentTarget.name] = evt.currentTarget.value;
        this.setState(fldChange, () => { this.allFieldsAreValid() });
    }

    getTotalCount = () => {
        return this.state.Small
            + this.state.Medium
            + this.state.Large
            + this.state.XLarge
            + this.state.XXL
            + this.state.XXXL
            + this.state.YXSmall
            + this.state.YSmall
            + this.state.YMedium
            + this.state.YLarge
            + this.state.YXLarge;
    }

    countsAreNegative = () => {
        return this.state.Small < 0
            || this.state.Medium < 0
            || this.state.Large < 0
            || this.state.XLarge < 0
            || this.state.XXL < 0
            || this.state.XXXL < 0
            || this.state.YXSmall < 0
            || this.state.YSmall < 0
            || this.state.YMedium < 0
            || this.state.YLarge < 0
            || this.state.YXLarge < 0;
    }

    emailIsValid = () => {
        return Tgcc.IsValidEmail(this.state.Email);
    }

    allFieldsAreValid = () => {
        var total = this.getTotalCount();

        if (this.countsAreNegative())
            this.setState({ error: 'Negative item count is not valid.', isWaiting: false });

        else if (total < 1)
            this.setState({ error: 'Please indicate at least one size to order.', isWaiting: false });

        else if (!this.state.FirstName.trim())
            this.setState({ error: 'First name cannot be blank.', isWaiting: false });

        else if (!this.state.LastName.trim())
            this.setState({ error: 'Last name cannot be blank.', isWaiting: false });

        else if (!this.emailIsValid())
            this.setState({ error: 'Email is not valid.', isWaiting: false });

        else {
            var totalCt: number = this.getTotalCount();
            this.setState({ error: null })
            return true;
        }
        return false;
    }

    getSizes = () => {
        var sizes = new Tgcc.SizesRec;
        sizes.Small = this.state.Small;
        sizes.Medium = this.state.Medium;
        sizes.Large = this.state.Large;
        sizes.XLarge = this.state.XLarge;
        sizes.XXL = this.state.XXL;
        sizes.XXXL = this.state.XXXL;
        sizes.YXSmall = this.state.YXSmall;
        sizes.YSmall = this.state.YSmall;
        sizes.YMedium = this.state.YMedium;
        sizes.YLarge = this.state.YLarge;
        sizes.YXLarge = this.state.YXLarge;
        return sizes;
    }

    disableEdits = () => {
        if (this.props.purchaseComplete || this.state.purchaseComplete) {
            var inputs = document.getElementsByTagName("input");
            for (var i = 0; i < inputs.length; i++)
                inputs[i].setAttribute('disabled', 'disabled');
        }
    }

    buyNow = () => {
        // Request.orderTvite(this.props.tvite.code,
        //     this.props.tvite.proofId,
        //     this.state.Organization,
        //     this.state.FirstName,
        //     this.state.LastName,
        //     this.state.Email,
        //     this.getTotalCount(),
        //     this.state.individualShip || this.props.tvite.shipType == Tgcc.ShipmentTypes.Individual,
        //     this.state.address1,
        //     this.state.address2,
        //     this.state.city,
        //     this.state.state,
        //     this.state.zip,
        //     this.getSizes(),
        //     this.orderComplete,
        //     this.orderFailed);
    }

    freeShipContent = () => {
        return (
            <div style={proseStyle}>
                <div style={shipHdrStyle}>Bulk Shipping</div>
                Thank you for ordering through the<br />Graphic Cow Company.<br /><br />
                Apparel ordered will be BULK SHIPPED to the individual who organized the design with us.<br /><br />
                Each item will be bagged & tagged by name and size for easy distribution.<br /><br />
                Please contact us at 1-800-472-3269 if you have any questions.<br /><br />
                <div style={szRowStyle}><hr style={hrStyle} /></div>
            </div>
        )
    }

    directShipContent = () => {
        var editDisabled = this.props.purchaseComplete || this.state.purchaseComplete;
        return (
            <div style={proseStyle}>
                <div style={shipHdrStyle}>Individual Shipping</div>
                Thank you for ordering through the<br />Graphic Cow Company.<br /><br />
                All apparel ordered will be fulfilled through <span style={inlineHighlightAllCaps}>INDIVIDUAL SHIPPING</span> directly to you. Once your order has been placed, no changes to the address submitted can be made.<br /><br />
                Individually shipped orders will be shipped out in <span style={inlineHighlightBold}>7-10 business days</span> after the link has been closed.<br /><br />
                Please contact us at 1-800-472-3269 if you have any questions.<br />
                <div style={szRowStyle}><hr style={hrStyle} /></div>
                <div>
                    <h3 id="shipping">Please provide your Shipping Address:</h3>
                    <div style={rowStyle}>
                        <input name="address1" style={addrlineStyle} placeholder="Address line 1" onChange={this.handleFieldChange} defaultValue={this.state.address1} disabled={editDisabled} />
                    </div>
                    <div style={rowStyle}>
                        <input name="address2" style={addrlineStyle} placeholder="Address line 2 (optional)" onChange={this.handleFieldChange} defaultValue={this.state.address2} disabled={editDisabled} />
                    </div>
                    <div style={rowStyle}>
                        <input name="city" style={cityStyle} placeholder="City" onChange={this.handleFieldChange} disabled={editDisabled} />
                        <input name="state" style={stateStyle} placeholder="State" onChange={this.handleFieldChange} disabled={editDisabled} />
                        <input name="zip" style={zipStyle} placeholder="Zip code" onChange={this.handleFieldChange} disabled={editDisabled} />
                    </div>
                </div>
            </div>
        )
    }

    setIndividualShip = (turnOn: boolean) => {
        this.setState({ individualShip: turnOn })
    }

    getIndividualShipSection = () => {
        var editDisabled = this.props.purchaseComplete || this.state.purchaseComplete;
        if (this.props.tvite.shipType == Tgcc.ShipmentTypes.Select) {
            var shipContent = this.state.individualShip ? this.directShipContent() : this.freeShipContent();
            return (
                <div>
                    <div style={hdrStyle}>Choose your shipping:</div>
                    <div style={checkRowStyle}>
                        <div style={checkLabelStyle}>Bulk Shipping</div>
                        <div style={checkLabelStyle}>Individual</div>
                    </div>
                    <div style={checkRowStyle}>
                        <input style={shipCheckStyle} type="checkbox" checked={!this.state.individualShip} onChange={() => this.setIndividualShip(false)} disabled={editDisabled} />
                        <input style={shipCheckStyle} type="checkbox" checked={this.state.individualShip} onChange={() => this.setIndividualShip(true)} disabled={editDisabled} />
                    </div>
                    {shipContent}
                </div>
            )
        } else if (this.props.tvite.shipType == Tgcc.ShipmentTypes.Individual) {
            return this.directShipContent();
        } else {
            return this.freeShipContent();
        }
    }

    getYouthSizes() {
        var editDisabled = this.props.purchaseComplete || this.state.purchaseComplete;
        if (this.props.tvite.youthSizes) {
            return (
                <div>
                    <div style={rowStyle}><hr style={hrStyle} /></div>
                    <div>
                        <div style={szRowStyle}>
                            <div style={szLblStyle}>YXSmall:</div>
                            <input type="number" name="YXSmall" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange} disabled={editDisabled} />
                            <div style={szDivider}></div>
                            <div style={szLblStyle}>YLarge:</div>
                            <input type="number" name="YLarge" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange} disabled={editDisabled} />
                        </div>
                        <div style={szRowStyle}>
                            <div style={szLblStyle}>YSmall:</div>
                            <input type="number" name="YSmall" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange} disabled={editDisabled} />
                            <div style={szDivider}></div>
                            <div style={szLblStyle}>YXLarge:</div>
                            <input type="number" name="YXLarge" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange} disabled={editDisabled} />
                        </div>
                        <div style={szRowStyle}>
                            <div style={szLblStyle}>YMedium:</div>
                            <input type="number" name="YMedium" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange} disabled={editDisabled} />
                            <div style={szLblStyle}></div>
                            <div style={szLblStyle}></div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    orderComplete = () => {
        this.setState({ purchaseComplete: true, isWaiting: false });
    }

    orderFailed = (err) => {
        this.setState({ error: err, isWaiting: false });
    }

    render() {
        if (!this.props.tvite)
            return Tgcc.workingGif;

        if (this.props.tvite.status == 'CLOSED')
            return <div style={closedBtn}>Sorry, this T-Vite is now closed</div>

        var totalCt: number = this.getTotalCount();
        var price: number = this.props.tvite.price;
        var total: number = (totalCt * price);

        var completed = this.props.purchaseComplete || this.state.purchaseComplete;
        var canBuy = !completed && !this.state.error && this.state.FirstName && this.state.LastName && this.state.Email && totalCt;

        var buyButtnStyle = canBuy ? orderBtn : Object.assign({}, orderBtn, { opacity: 0.5 });
        var buyButton = completed ? <div style={thanksStyle}>Thank you!</div> : <div style={buyButtnStyle} onClick={this.buyNow}>Place your order</div>;

        var error = completed ? <div style={errorStyle}>Order Received</div>
            : this.state.error ? <div style={errorStyle}>{this.state.error}</div> : <div style={errorStyle}></div>;
        var small = this.checkXSmall() ? <div style={szRowStyle}>XSmall: <input type="number" name="XSmall" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange} /></div> : <div></div>

        return (
            <div style={wrapperStyle}>
                {error}
                <div style={rowStyle}>
                    <div style={nameLblStyle}>Full Name:</div>
                    <input type="text" name="FirstName" placeholder="first name" style={nameStyle} onChange={this.handleFieldChange} disabled={completed} />
                    <input type="text" name="LastName" placeholder="last name" style={nameStyle} onChange={this.handleFieldChange} disabled={completed} />
                </div>
                <div style={rowStyle}>
                    <div style={emailLblStyle}>Email:</div>
                    <input type="email" name="Email" placeholder="email address" style={emailStyle} onChange={this.handleFieldChange} disabled={completed} />
                </div>
                {this.getIndividualShipSection()}

                <div style={rowStyle}><hr style={hrStyle} /></div>

                <div style={szRowStyle}>
                    <div style={szLblStyle}>Small:</div>
                    <input type="number" name="Small" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange} disabled={completed} />
                    <div style={szDivider}></div>
                    <div style={szLblStyle}>XLarge:</div>
                    <input type="number" name="XLarge" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange} disabled={completed} />
                </div>
                <div style={szRowStyle}>
                    <div style={szLblStyle}>Medium:</div>
                    <input type="number" name="Medium" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange} disabled={completed} />
                    <div style={szDivider}></div>
                    <div style={szLblStyle}>2XLarge:</div>
                    <input type="number" name="XXL" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange} disabled={completed} />
                </div>
                <div style={szRowStyle}>
                    <div style={szLblStyle}>Large:</div>
                    <input type="number" name="Large" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange} disabled={completed} />
                    <div style={szDivider}></div>
                    <div style={szLblStyle}>3XLarge:</div>
                    <input type="number" name="XXXL" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange} disabled={completed} />
                </div>
                {this.getYouthSizes()}
                <div style={rowStyle}><hr style={hrStyle} /></div>
                <div style={{ display: 'flex', height: '50px', justifyContent: 'center' }}>
                    {buyButton}
                </div>
            </div>
        )
    }
}
